exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-4913e672","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/player/page/toptextdownpic.vue
// module id = 68
// module chunks = 0